export default "__VITE_PUBLIC_ASSET__f1d93dd7__"